module.exports = __webpack_public_path__ + "img/radial-counter.7b475b34.svg";